export const educationData = [
    {
        id: 1,
        institution: 'Instituto Tecnológico de Mexicali',
        course: 'Computer Systems Engineering',
        startYear: '2020',
        endYear: '2024'
    },
    {
        id: 2,
        institution: 'CECYTE BC Plantel Compuertas',
        course: 'Software Technician - Higher Secondary Education',
        startYear: '2017',
        endYear: '2020'
    },
]